// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown_container{width:100%}.dropdown_container_masthead{display:flex;justify-content:space-between;align-items:baseline;cursor:pointer}.dropdown_container_heading{font-weight:bold;font-size:18px}.dropdown_container_divider_top{margin-bottom:15px}.dropdown_container_divider_bottom{margin-top:15px}\n", ""]);
// Exports
module.exports = exports;
